import React from 'react';
import * as api from "../api.js"
import Loading from "./Loading.jsx"

class FileUnlocker extends React.Component {
	state = {
		input:'',
		documents:[],
		status: 0,
		isLoading: false
	}

	handleChange = (e) => {
		this.setState({input: e.target.value})
	}

	submitCase = (e) => {
		this.setState({isLoading: true})
		api.getUserDocs(this.state.input).then((res) => {
			console.log(res)
			res.docs.forEach(doc => {
				doc.isUnlocked = false
			})
			this.setState({documents: res.docs, status: res.status, isLoading: false}) })
	}

	unlockDocument = (i, documentCode) => {
		this.setState({isLoading: true});
		console.log(documentCode)
		api.patchDocActioned(documentCode).then((res) => {
			if (res.status === 204) {
				console.log(res)
				this.setState((currentState) => {
					currentState.documents[i].isUnlocked = true;
					return {documents: currentState.documents, isLoading: false}
				})
			} else {
				console.log(res)
				this.setState({status: 500, isLoading: false})
			}
		});
		
	}

	render() {
		const { status, documents, isLoading } = this.state;
		return <div className="fileUnlocker">
			<label className="fileUnlocker-case"> 
				Enter Case #:
				<input type="text" onChange={this.handleChange} className="fileUnlocker-case-input" value={this.state.input}></input>
			</label>
			

			<div className="fileUnlocker-case-button" onClick={this.submitCase}>Submit</div>
			{isLoading === true ?
			<Loading /> :
			<>
			{status === 0 ? null : 
			<div className="fileUnlocker-container-forms">
				{status === 500 ? <p className="fileUnlocker-form-error">File Unlock failed, please try again</p>:
				<>
				{status === 404 ? 
				<p className="fileUnlocker-form-error">Invalid Case Number</p> : 
				<>
					{status === 200 && documents.length === 0 ? 
					<p className="fileUnlocker-form-error">There are no submitted files on this Case</p> : 
					documents.map((document, index) => {
						return <div key ={`document ${document.DocumentCode}`} className="fileUnlocker-grid-form">
							<h3 className="fileUnlocker-form-title" >{`${document.Details} (${document.DocumentCode})`}</h3>
							{document.isUnlocked === true ? 
								<div className="fileUnlocker-form-button-grey">Unlocked</div> : 
								<div className="fileUnlocker-form-button" onClick={(e) => {this.unlockDocument(index, document.DocumentCode)}}>Unlock</div>
							}
						</div>
					})} 
				</>}
				</>}
			</div>}
			</>
			}

		</div>
	}
}

export default FileUnlocker;